import { useCallback, useEffect, useState } from "react";
import {
  GINJA_BRAND_UPDATED_EVENT,
  readCachedBrandSettings,
  type GinjaBrandSettingsData,
} from "@/services/ginjaBrand";

export function useGinjaBrand(): GinjaBrandSettingsData | null {
  const [data, setData] = useState<GinjaBrandSettingsData | null>(() =>
    typeof window === "undefined" ? null : readCachedBrandSettings(),
  );

  const refresh = useCallback((ev?: Event) => {
    const d = (ev as CustomEvent<GinjaBrandSettingsData>)?.detail;
    setData(d ?? readCachedBrandSettings());
  }, []);

  useEffect(() => {
    refresh();
    window.addEventListener(GINJA_BRAND_UPDATED_EVENT, refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener(GINJA_BRAND_UPDATED_EVENT, refresh);
      window.removeEventListener("storage", refresh);
    };
  }, [refresh]);

  return data;
}
